'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();

import { useQueryClient } from '@tanstack/react-query';
import { Button } from '@workspace/ui/components/button';
import { AlertDialog } from '@workspace/ui/components/custom/alert-dialog';
import { useState } from 'react';
import { KYCVerificationDialog } from '@/components/wallet/kyc-verification-dialog';
import { RESTRICTION_MODAL_VARIANTS, type RestrictionModalVariant } from '@/types/restriction';

interface RestrictionDialogProps {
  variant: RestrictionModalVariant;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const suspensionDescription = (
  <>
    Additional documents may be requested, potentially causing slight transaction delays.
    <br /> <br /> There will be a temporary suspension on your ability to proceed with any
    transactions on our platform. We appreciate your patience and cooperation.
    <br /> <br /> For concerns, please contact our support team. Thank you for your understanding.
  </>
);

const finalRejectionDescription = (
  <>
    We regret to inform you that your verification has been rejected.
    <br /> <br />
    For further details and assistance, please contact our support team who will be able to provide
    you with more information and guide you through the next steps.
  </>
);

function getRestrictionDialogCopy(variant: RestrictionModalVariant) {
  if (variant === RESTRICTION_MODAL_VARIANTS.SUSPENSION) {
    return {
      alertVariant: 'warning' as const,
      title: 'Temporary suspension on payment actions',
      description: suspensionDescription,
    };
  }

  return {
    alertVariant: 'error' as const,
    title: 'Final rejection',
    description: finalRejectionDescription,
  };
}

export function RestrictionDialog({ variant, open, onOpenChange }: RestrictionDialogProps) {
  const [isVerificationFlowActive, setIsVerificationFlowActive] = useState(false);
  const queryClient = useQueryClient();
  const isFirstRejection = variant === RESTRICTION_MODAL_VARIANTS.FIRST_REJECTION;

  // Keep KYC mounted after the intro closes so the Sumsub dialog can take over.
  if (isFirstRejection && open && !isVerificationFlowActive) {
    setIsVerificationFlowActive(true);
  }

  const handleContactUs = () => {
    onOpenChange(false);
    window.dispatchEvent(new Event('toggle-hubspot-chat'));
  };

  const handleKYCClose = () => {
    setIsVerificationFlowActive(false);
    onOpenChange(false);
    void queryClient.invalidateQueries({ queryKey: ['user-restriction'] });
  };

  if (variant === RESTRICTION_MODAL_VARIANTS.NONE && !isVerificationFlowActive) return null;

  const dialogCopy =
    variant === RESTRICTION_MODAL_VARIANTS.NONE || isFirstRejection
      ? null
      : getRestrictionDialogCopy(variant);

  return (
    <>
      {dialogCopy && (
        <AlertDialog
          open={open}
          onOpenChange={onOpenChange}
          variant={dialogCopy.alertVariant}
          title={dialogCopy.title}
          description={dialogCopy.description}
        >
          <Button variant="primary" className="w-full" onClick={handleContactUs}>
            Contact us
          </Button>
          <Button variant="secondary" className="w-full" onClick={() => onOpenChange(false)}>
            Close
          </Button>
        </AlertDialog>
      )}
      {((isFirstRejection && open) || isVerificationFlowActive) && (
        <KYCVerificationDialog
          isKYCDialogOpen={open}
          setIsKYCDialogOpen={onOpenChange}
          title="Verify your identity"
          description="Complete identity verification to continue using payment actions on our platform."
          onClose={handleKYCClose}
        />
      )}
    </>
  );
}
